export enum ChatRuleEnum {
  ENABLE_CHAT_FOR_COLLEAGUES = 'ENABLE_CHAT_FOR_COLLEAGUES',
  FORBIDD_EVERYONE = 'FORBIDD_EVERYONE',
  IGNORE = 'IGNORE'
}
